<template>
  <client-only>
    <div class="share-post">
      <span class="d-block text-caption mb-1">
        Share this post:
      </span>
      <vue-goodshare-facebook
        :page_url="`https://100asa.com/blog/${uid}/`"
        has_icon
      />
      <vue-goodshare-twitter
        :page_url="`https://100asa.com/blog/${uid}/`"
        has_icon
      />
      <vue-goodshare-vkontakte
        :page_url="`https://100asa.com/blog/${uid}/`"
        has_icon
      />
      <vue-goodshare-linkedin
        :page_url="`https://100asa.com/blog/${uid}/`"
        has_icon
      />
      <vue-goodshare-reddit
        :page_url="`https://100asa.com/blog/${uid}/`"
        has_icon
      />
    </div>
  </client-only>
</template>

<script>
export default {
  name: 'SharePost',
  props: {
    uid: {
      type: String,
      required: true
    }
  }
}
</script>
